module.exports = "/_next/static/images/image5-798874e90369e979e931ff66e12dd4fd.png";